import React from 'react';
import Routers from './router/index';
import './app.css'
window.addEventListener('load', () => {
  document.body.className = localStorage.themelocation || ""
})
class App extends React.Component {
  componentWillMount() {
    if (localStorage.getItem("darkTheme")) {
      if (localStorage.getItem("darkTheme") == 'true') {
        import('./indexDark.css').then(() => {
          //  require("./indexDark.css")
        });
      } else {
        import('./index.css').then(() => {
          // require("./index.css")
        });
      }
    } else {
      import('./index.css').then(() => {
        // require("./index.css")
      });
    }
  }
  render() {
    return (
      <Routers language={this.props.language} />
    );
  }
}



export default App


